var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-container"},[_c('v-progress-circular',{attrs:{"rotate":-90,"size":100,"width":15,"value":_vm.value,"color":_vm.color}},[_c('span',{staticClass:"percentage"},[_vm._v(_vm._s(_vm.value)+"%")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }